import gql from 'graphql-tag';
import { CommentsFragments } from '@getaccept/dsr-shared-new/src/api/contextual-commenting/graphql/comments.fragments';

export class CommentsMutations {
  static create = gql`
    mutation CreateContextualComment($payload: CreateDealroomCommentInput!) {
      createDealroomContextualComment(payload: $payload) {
        ...dealroomCommentFragment
      }
    }
    ${CommentsFragments.comment}
  `;

  static update = gql`
    mutation UpdateContextualComment($payload: UpdateDealroomCommentInput!, $commentId: String!) {
      updateDealroomContextualComment(payload: $payload, commentId: $commentId)
    }
  `;

  static createReply = gql`
    mutation CreateContextualCommentReply(
      $payload: DealroomCommentReplyInput!
      $commentId: String!
    ) {
      addDealroomContextualCommentReply(payload: $payload, commentId: $commentId) {
        ...dealroomReplyFragment
      }
    }
    ${CommentsFragments.reply}
  `;

  static setReadBy = gql`
    mutation SetReadCommentsAndReplies(
      $payload: SetDealroomContextualCommentsAndRepliesReadbyInput!
    ) {
      setDealroomContextualCommentsAndRepliesReadBy(payload: $payload)
    }
  `;

  static delete = gql`
    mutation DeleteContextualComment($commentId: String!) {
      deleteDealroomContextualComment(commentId: $commentId)
    }
  `;
}
